module.exports = __webpack_public_path__ + "img/sidebar_cabinet.c946e817.svg";